import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import DashboardPage from './pages/DashboardPage/DashboardPage';
import NewGamePage from './pages/NewGamePage/NewGamePage';
import StoreProvider from './utils/store';
import Modal from './components/Modal/Modal';
import Overlay from './components/Overlay/Overlay';
import EditGamePage from './pages/EditGamePage/EditGamePage';
import EditQuestionPage from './pages/EditQuestionPage/EditQuestionPage';
import ResultPage from './pages/ResultPage/ResultPage';
import JoinPage from './pages/JoinPage/JoinPage';
import PlayGamePage from './pages/PlayGamePage/PlayGamePage';
import LobbyPage from './pages/LobbyPage/LobbyPage';
import PlayResultPage from './pages/PlayResultPage/PlayResultPage';
function App () {
  return (
    <StoreProvider>
      <>
        <Router basename='/BigBrain'>
          <Switch>
            <Route path='/login'>
              <LoginPage />
            </Route>
            <Route path='/register'>
              <RegisterPage />
            </Route>
            <Route exact path='/'>
              <DashboardPage />
            </Route>
            <Route path='/newgame'>
              <NewGamePage />
            </Route>
            <Route path='/lobby/:sessionid/:gameid/:playerid'>
              <LobbyPage />
            </Route>
            <Route exact path='/game/result/:sessionid'>
              <ResultPage />
            </Route>
            <Route exact path='/game/:gameid'>
              <EditGamePage />
            </Route>
            <Route exact path='/game/:gameid/:qid'>
              <EditQuestionPage />
            </Route>
            <Route exact path='/play/join/:sessionid/:gameid'>
              <JoinPage />
            </Route>
            <Route exact path='/play/:sessionid/:gameid/:playerid'>
              <PlayGamePage />
            </Route>
            <Route exact path='/play/result/:playerid'>
              <PlayResultPage />
            </Route>
          </Switch>
        </Router>
        <Overlay />
        <Modal />
      </>
    </StoreProvider>
  );
}

export default App;
